export default __webpack_public_path__ + "static/media/background-large-pink.06e03865.png";